module.exports = __webpack_public_path__ + "static/media/BurgerKing.23abad1e.svg";